module.exports = __webpack_public_path__ + "static/img/W.8715f47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qh/W.png
// module id = RYNO
// module chunks = 0